const styles = {
  root: {
    position: "fixed",
    top: 0,
    bottom: 0,
    left: 0,
    backgroundColor: "primary.main",
    zIndex: 100,
    px: 1,
  },
  topLogo: {
    height: 30,
    my: 2,
    mb: 3,
    cursor: "pointer",
  },
  button: {
    display: "flex",
    justifyContent: "center",
    width: 55,
    height: 55,
    borderRadius: 3,
  },
  active: {
    backgroundColor: "#09362b",
  },
  activeText: {
    color: "white",
  },
  inactiveText: {
    color: "#c3cccbff",
  },
  link: {
    textDecoration: "none",
  },
  iconText: {
    fontSize: 10,
    fontWeight: 600,
    color: "#96b1a9",
    textDecoration: "none",
  },
};

export default styles;
